import $ from 'jquery';
import 'select2';

const defaults = {};

function HomeSignUp(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.init();
}

HomeSignUp.prototype = {
  init() {
    const $select = this.$element.find('#edit-submitted-pick-a-location');
    $select.select2({
      placeholder: 'Pick a Location',
    });
  },
};

export default HomeSignUp;
